import React from "react";
var __jsx = React.createElement;
import { Icon } from "@syarahtech/ui";
import { usePriceOfferContext } from "@/common/Contexts/PriceOfferContextProvider";
import { useTranslation } from "@i18n";
import { useState } from "react";
import { twMerge } from "tailwind-merge";
var PriceOfferCitySearch = function PriceOfferCitySearch(_ref) {
  var onSubmit = _ref.onSubmit;
  var _usePriceOfferContext = usePriceOfferContext(),
    actions = _usePriceOfferContext.actions,
    selectedCity = _usePriceOfferContext.selectedCity,
    state = _usePriceOfferContext.state,
    cities = _usePriceOfferContext.cities;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useState = useState(""),
    searchTerm = _useState[0],
    setSearchTerm = _useState[1];
  var _useState2 = useState(selectedCity),
    currentCity = _useState2[0],
    setCurrentCity = _useState2[1];
  var handleSearchTermChange = function handleSearchTermChange(value) {
    setSearchTerm(value);
    actions.searchCities(value);
  };
  var handleClearSearch = function handleClearSearch() {
    setSearchTerm("");
    actions.resetCitiesSearch();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "md:flex md:flex-col md:gap-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center text-primary text-sm font-bold hidden md:block"
  }, tShort("price_offer/change_city_screen_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 pt-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "border border-gray-gainsboro border-solid rounded"
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--search-rounded",
    width: 6,
    height: 6,
    className: "absolute right-3 top-1/2 transform -translate-y-1/2 w-6 h-6 text-primary-80"
  }), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: tShort("price_offer/city_search_placeholder", {
      ns: "web_sell_trade"
    }),
    name: "city",
    value: searchTerm,
    onChange: function onChange(e) {
      return handleSearchTermChange(e.target.value);
    },
    className: "w-full ps-10 pe-4 py-2 bg-white rounded-xl border-0 transition-all text-right placeholder:text-primary-80",
    dir: "rtl",
    autoComplete: "off"
  }), searchTerm !== "" && /*#__PURE__*/React.createElement("span", {
    onClick: handleClearSearch,
    className: "absolute left-3 top-1/2 transform -translate-y-1/2 w-6 h-6 text-primary-80 cursor-pointer"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-rounded",
    width: 6,
    height: 6,
    className: "text-gray-text"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col"
  }, cities.length > 0 ? cities === null || cities === void 0 ? void 0 : cities.map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: twMerge("flex items-center py-3 cursor-pointer border-b border-solid border-gray-gainsboro min-h-12 max-h-12", (cities.length < 2 || i === cities.length - 1) && "border-b-0"),
      onClick: function onClick() {
        return setCurrentCity(item);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex w-full justify-between items-center"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-neutral-100 text-sm font-semibold"
    }, item.name_ar), (currentCity === null || currentCity === void 0 ? void 0 : currentCity.id) === item.id && /*#__PURE__*/React.createElement(Icon, {
      icon: "material-symbols--check-circle-rounded",
      width: 6,
      height: 6,
      className: "text-primary"
    })));
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex items-center gap-2 overflow-hidden justify-center"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-neutral-100 text-sm font-semibold text-center"
  }, tShort("price_offer/city_search_no_results", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "text-primary text-sm font-bold text-center",
    onClick: handleClearSearch
  }, tShort("price_offer/city_search_no_results_reset", {
    ns: "web_sell_trade"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "fixed bottom-0 w-full left-0 px-4 py-6 md:relative md:p-0 bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-col gap-4 md:flex-row-reverse md:gap-3 md:justify-start"
  }, /*#__PURE__*/React.createElement("button", {
    className: twMerge("transition-colors duration-200 ease-in", "w-full p-3 bg-primary text-white rounded text-center font-bold border-none outline-none text-base md:max-w-[200px] cursor-pointer hover:bg-primary-120 transition-colors duration-200 ease-in", "disabled:bg-[#E8EFF6] disabled:text-[#92A5C1] disabled:cursor-not-allowed disabled:pointer-events-none", "md:max-w-[360px] md:mx-auto"),
    disabled: !currentCity || (currentCity === null || currentCity === void 0 ? void 0 : currentCity.id) === (selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.id),
    onClick: function onClick() {
      actions.changeSelectedCity(currentCity.id);
      onSubmit();
      actions.resetCitiesSearch();
    }
  }, tShort("price_offer/change_city_submit", {
    ns: "web_sell_trade"
  })))))));
};
export default PriceOfferCitySearch;